import client from "../Client/HttpClient";
import { ISystemSubjectsModel } from "@/interfaces/modules";

const ApiPath = "SystemSubjects";

export default {
  GetSubjects: (): Promise<ISystemSubjectsModel[]> => client.get(`${ApiPath}`),
  GetSubjectById: (data: ISystemSubjectsModel): Promise<ISystemSubjectsModel> =>
    client.get(`${ApiPath}/${data.Id}`),
  PostSubject: (data: ISystemSubjectsModel): Promise<ISystemSubjectsModel> =>
    client.post(`${ApiPath}`, data),
};
